interface IAttendeeCardProps {
  attendee: {
    orderId: number;
    firstName: string;
    lastName: string;
    title: string;
    companyName: string;
    email: string;
    country: {
      nameSwe: string;
      nameInt: string;
      alpha2Code: string;
    };
    telephone: string;
    bio: string;
    profileImage: string;
    linkedIn: string;
  };
  fields: string[];
  lang: string;
  hideImage?: boolean;
}

export default function AttendeeListItem({ attendee, fields = [], lang, hideImage = false }: IAttendeeCardProps) {
  function goToLinkedIn() {
    window.open(attendee.linkedIn, '_blank');
  }
  return (
    <div className="card  p-4 border rounded-none flex justify-between relative w-full">
      <div className="flex">
        <div className="flex gap-2">
          {!hideImage && (
            <div
              className="
          h-12 w-12 rounded-full overflow-hidden mr-4   z-10"
            >
              <img
                src={attendee.profileImage || 'https://t4.ftcdn.net/jpg/00/64/67/27/360_F_64672736_U5kpdGs9keUll8CRQ3p3YaEv2M6qkVY5.jpg'}
                alt="profile"
                className="w-full h-auto object-cover rounded-full"
              />
            </div>
          )}
          <div className="flex flex-col">
            <span className="font-semibold text-sm mb-2">
              {attendee.firstName} {attendee.lastName}
            </span>
            {attendee?.country && fields.includes('country') && (
              <div className="text-xs opacity-80 font-normal mb-1 flex items-center gap-2 justify-start">
                <div className="h-3 w-3 flex items-center">
                  <img src={`https://flagcdn.com/${attendee.country?.alpha2Code?.toLowerCase()}.svg`} className="w-full object-cover " />
                </div>
                <span>{lang === 'swe' ? attendee.country.nameSwe : attendee.country.nameInt}</span>
              </div>
            )}
            {(attendee.title || attendee.companyName) && (fields.includes('title') || fields.includes('company')) && (
              <span className="text-xs opacity-80 font-normal mb-1">
                <i className="ri-briefcase-line mr-1"></i>
                {fields.includes('title') && attendee.title}{' '}
                {attendee.title && fields.includes('title') ? ` • ${attendee.companyName}` : fields.includes('company') && attendee.companyName}
              </span>
            )}
            {attendee.email && fields.includes('email') && (
              <span className="text-xs opacity-80 font-normal mb-1">
                <i className="ri-mail-line mr-1"></i>
                {attendee.email}
              </span>
            )}
            {attendee.telephone && fields.includes('telephone') && (
              <span className="text-xs opacity-80 font-normal mb-1">
                <i className="ri-phone-line mr-1"></i>
                {attendee.telephone}
              </span>
            )}
          </div>
        </div>
      </div>
      {attendee.linkedIn && fields.includes('linkedIn') && (
        <button
          style={{
            color: 'white',
          }}
          onClick={goToLinkedIn}
          className="bg-sky-700  text-white flex text-sm w-fit h-fit  px-4 ml-auto items-center rounded-full justify-center leading-none p-2 py-3 mt-4"
        >
          <i
            style={{
              color: 'white',
            }}
            className="ri-linkedin-box-fill ri-lg font-normal mr-2 mt-[2px]"
          ></i>
          LinkedIn
        </button>
      )}
    </div>
  );
}
